import qs from 'querystringify';
import remote from './remote';

const URL = {
  UNIVERSAL: `/message/universal/${process.env.VUE_APP_SERVICE_GROUP}`,
  UNIVERSAL_LIST: `/message/universal/list/${process.env.VUE_APP_SERVICE_GROUP}`,
  RSS: `/message/rss/${process.env.VUE_APP_SERVICE_GROUP}`,
  RSS_LIST: `/message/rss/list/${process.env.VUE_APP_SERVICE_GROUP}`,
  LIVESTREAM: `/message/livestream/${process.env.VUE_APP_SERVICE_GROUP}`,
  LIVESTREAM_LIST: `/message/livestream/list/${process.env.VUE_APP_SERVICE_GROUP}`,
  LIVESTREAM_STATUS: '/message/livestream/status',
  DISASTER: `/disaster/${process.env.VUE_APP_SERVICE_GROUP}`,
  DISASTER_LIST: `/disaster/list/${process.env.VUE_APP_SERVICE_GROUP}`,
  //   RSS: `/message/rss/${process.env.VUE_APP_SERVICE_GROUP}`,
  WEATHER: '/api/weather/nowcast',
};

export default {
  getUniversalMessageInfo(clientId) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.UNIVERSAL)}/${clientId}`,
    });
  },
  addUniversalMessageInfo(addBody) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.UNIVERSAL)}`,
      method: remote.METHOD.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      data: addBody,
    });
  },
  updateUniversalMessageInfo(updateBody) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.UNIVERSAL)}`,
      method: remote.METHOD.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      data: updateBody,
    });
  },
  deleteUniversalMessageInfo(queryString) {
    let url = `${remote.getWowserviceUrl(URL.UNIVERSAL)}`;

    if (queryString) {
      url = `${url}?${qs.stringify(queryString)}`;
    }
    return remote.request({ url, method: remote.METHOD.DELETE });
  },
  getUniversalMessageList(queryString) {
    let url = `${remote.getWowserviceUrl(URL.UNIVERSAL_LIST)}`;

    if (queryString) {
      url = `${url}?${qs.stringify(queryString)}`;
    }
    return remote.request({ url });
  },
  getRssInfo(clientId) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.RSS)}/${clientId}`,
    });
  },
  addRssInfo(addBody) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.RSS)}`,
      method: remote.METHOD.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      data: addBody,
    });
  },
  updateRssInfo(updateBody) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.RSS)}`,
      method: remote.METHOD.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      data: updateBody,
    });
  },
  deleteRssInfo(queryString) {
    let url = `${remote.getWowserviceUrl(URL.RSS)}`;

    if (queryString) {
      url = `${url}?${qs.stringify(queryString)}`;
    }
    return remote.request({ url, method: remote.METHOD.DELETE });
  },
  getRssList(queryString) {
    let url = `${remote.getWowserviceUrl(URL.RSS_LIST)}`;

    if (queryString) {
      url = `${url}?${qs.stringify(queryString)}`;
    }
    return remote.request({ url });
  },
  getLivestreamInfo(clientId) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.LIVESTREAM)}/${clientId}`,
    });
  },
  addLivestreamInfo(addBody) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.LIVESTREAM)}`,
      method: remote.METHOD.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      data: addBody,
    });
  },
  updateLivestreamInfo(updateBody) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.LIVESTREAM)}`,
      method: remote.METHOD.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      data: updateBody,
    });
  },
  deleteLivestreamInfo(queryString) {
    let url = `${remote.getWowserviceUrl(URL.LIVESTREAM)}`;

    if (queryString) {
      url = `${url}?${qs.stringify(queryString)}`;
    }
    return remote.request({ url, method: remote.METHOD.DELETE });
  },
  getLivestreamStatus(videoId) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.LIVESTREAM_STATUS)}/${videoId}`,
    });
  },
  getLivestreamList(queryString) {
    let url = `${remote.getWowserviceUrl(URL.LIVESTREAM_LIST)}`;

    if (queryString) {
      url = `${url}?${qs.stringify(queryString)}`;
    }
    return remote.request({ url });
  },
  getUrgentMessageList(queryString) {
    let url = `${remote.getWowserviceUrl(URL.DISASTER_LIST)}`;

    if (queryString) {
      url = `${url}?${qs.stringify(queryString)}`;
    }
    return remote.request({ url });
  },
  addUrgentMessageInfo(addBody) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.DISASTER)}`,
      method: remote.METHOD.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      data: addBody,
    });
  },
  updateUrgentMessageInfo(updateBody) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.DISASTER)}`,
      method: remote.METHOD.PUT,
      data: updateBody,
    });
  },
  deleteUrgentMessageInfo(queryString) {
    let url = `${remote.getWowserviceUrl(URL.DISASTER)}`;

    if (queryString) {
      url = `${url}?${qs.stringify(queryString)}`;
    }
    return remote.request({ url, method: remote.METHOD.DELETE });
  },
  getDisasterInfo(clientId) {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.DISASTER)}/${clientId}`,
    });
  },
  getWeather() {
    return remote.request({
      url: `${remote.getWowserviceUrl(URL.WEATHER)}/${process.env.VUE_APP_SERVICE_GROUP}`,
      timeout: 60000,
    });
  },
};
